var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle, _circle2, _path27, _path28, _path29, _path30, _polygon, _polygon2, _polygon3, _polygon4, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _rect, _rect2, _circle22, _circle23, _circle24, _circle25, _rect3, _polygon5, _rect4, _circle26, _line, _line2, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _circle27, _path40, _path41, _path42, _path43;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "d73490ac-7a9f-41f3-9c2f-a04fe0e68190",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 976.68,
    height: 840.3,
    viewBox: "0 0 976.68 840.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "40cb4f85-3adc-4f91-8af7-dda2654c63b5",
    x1: 915.78,
    y1: 706.9,
    x2: 915.78,
    y2: 252.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f74e0c91-e046-415c-8916-3730a2c068f9",
    x1: 582.97,
    y1: 706.75,
    x2: 582.97,
    y2: 221.19,
    xlinkHref: "#40cb4f85-3adc-4f91-8af7-dda2654c63b5"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gaming") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1002,485.82c-37.95,64.71-32.78,151.72-18,220.09,4.94,22.89,10.69,47,5.57,72.88-6.26,31.6-27.3,56.75-48.39,71.31-38.44,26.55-81.74,26.74-112.74.5-26.79-22.68-43.93-62.84-71.32-84.27-45.83-35.85-110.08-12.18-166.21,23.41-39.71,25.18-83.48,56.95-119.38,40.25-25.26-11.75-40.48-46.09-47.16-83.67-3.23-18.14-5-38-12.95-51.71-4.73-8.15-11.34-13.53-18.21-17.91-62.77-40-149.46-3.61-209.85-49.08-40.79-30.71-63.06-95.42-69.43-165s1.45-144.33,10.86-218c6.69-52.33,15.46-108.4,41.74-151.41,27.8-45.5,70.64-66.46,107.44-63s68.34,28,95.35,58.18c33.75,37.74,63.91,86.2,108.32,97.67,30.25,7.81,63.66-2.67,96.08-8.89,54.19-10.4,107.39-8.86,160.2-6.5,50.56,2.26,101.41,5.34,148.2,23.55,33.11,12.89,58.17,40.64,89,58.38,20.07,11.56,42.95,12.6,61.55,28.19,22.92,19.21,42.37,55.15,32.14,101.3C1055.08,426,1022.18,451.47,1002,485.82Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.41,689.83s-66.72-110.51-48-209.67c7.87-41.62,2.81-84.68-15.86-122.7a329,329,0,0,0-31.43-51.3",
    transform: "translate(-111.66 -29.85)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190.6,243.61c3.85,14.68-11.55,64.22-11.55,64.22s-37.75-35.59-41.61-50.27a27.48,27.48,0,0,1,53.16-14Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.88,313.39c-4.74,14.42-44.6,47.63-44.6,47.63s-12.35-50.39-7.6-64.81a27.48,27.48,0,1,1,52.2,17.18Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M290.43,452.84c-11.37,10-62.55,18.6-62.55,18.6s14.78-49.73,26.15-59.78a27.48,27.48,0,0,1,36.39,41.18Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M292.82,564.24c-9.51,11.83-58.5,28.9-58.5,28.9s6.16-51.52,15.67-63.34a27.48,27.48,0,0,1,42.83,34.44Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.22,378.51c13.21,7.46,65,5.18,65,5.18s-24.8-45.57-38-53a27.48,27.48,0,1,0-27,47.85Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.66,508.76c14.84,3.17,63.62-14.52,63.62-14.52S187,458.18,172.13,455a27.48,27.48,0,0,0-11.47,53.75Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.35,634.76c14.09,5.63,65.16-3.56,65.16-3.56s-30.67-41.85-44.76-47.48a27.48,27.48,0,0,0-20.39,51Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.6,243.61c3.85,14.68-11.55,64.22-11.55,64.22s-37.75-35.59-41.61-50.27a27.48,27.48,0,0,1,53.16-14Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M255.88,313.39c-4.74,14.42-44.6,47.63-44.6,47.63s-12.35-50.39-7.6-64.81a27.48,27.48,0,1,1,52.2,17.18Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M290.43,452.84c-11.37,10-62.55,18.6-62.55,18.6s14.78-49.73,26.15-59.78a27.48,27.48,0,0,1,36.39,41.18Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#fc6681"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M292.82,564.24c-9.51,11.83-58.5,28.9-58.5,28.9s6.16-51.52,15.67-63.34a27.48,27.48,0,0,1,42.83,34.44Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#fc6681"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M156.22,378.51c13.21,7.46,65,5.18,65,5.18s-24.8-45.57-38-53a27.48,27.48,0,1,0-27,47.85Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M160.66,508.76c14.84,3.17,63.62-14.52,63.62-14.52S187,458.18,172.13,455a27.48,27.48,0,0,0-11.47,53.75Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M182.35,634.76c14.09,5.63,65.16-3.56,65.16-3.56s-30.67-41.85-44.76-47.48a27.48,27.48,0,0,0-20.39,51Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.18,
    cy: 672.58,
    rx: 480.5,
    ry: 33,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.31,674.16s-.8-1.07-1.91-2.27l.32-.11s-14.28-35.69-11.1-50.76-12.69-51.55-12.69-51.55-23.41-47.94-12.33-86.2a102.72,102.72,0,0,0,2.86-13.73c3.31-22.66,2.14-27.33-3.41-35.61l-.61-.89a7,7,0,0,0,1.59-2.35C988.79,418,961.83,395,969,373.58c6.62-19.85-10.61-60.81-13.17-66.7l0,0-.29-.67-.86.28a20.92,20.92,0,0,1,5.66-13.73l.16-.16c2.38-2.19,5.27-3.8,7.5-6.15l.13-.15c.22-.21.45-.42.66-.64,2.21-2.32,3.72-5.76,2.52-8.74-1.09-2.72-4.15-4.38-4.87-7.22a37.15,37.15,0,0,1-.32-3.85c-.58-4-4.47-6.51-8-8.49-4.39-2.48-9-5-14.07-5.06-6.86,0-13,4.6-19.81,5.17-2.32.2-4.73-.08-6.93.69a15.43,15.43,0,0,0-4.55,2.92,22.38,22.38,0,0,0-2.22,2c-1.54,1.44-2.85,3.14-2.79,5.18a5.64,5.64,0,0,0,1.94,3.85,25.38,25.38,0,0,0,9.19,37.78c.08.55.16,1.11.24,1.7,1,7.51,1.59,18.13-1.08,26.45-11.39,5.87-29.14,15.44-32.32,19.69a3,3,0,0,0-.42,2.49,3.39,3.39,0,0,0-.06,1.19c-2.49.57-5.8,0-9.83-3.68-9.52-8.72-39.65-34.9-39.65-34.9s-13.48-33.31-23-27,11.1,37.28,11.1,37.28L869,381.51s1.59,10.31,18.24,4.76c5.5-1.83,10.47-3.58,14.67-5.09l1,.85c-3.75,21.94-5.69,51.18,8.14,59.76a13.38,13.38,0,0,1,2.3,4.82c-.07.26-.14.53-.2.79a76.15,76.15,0,0,0-2,13.34,42.42,42.42,0,0,0-3.51,18.94l-5.3,75.51s-.79,16.65,4.76,29.34,23,76.14,11.1,80.9l1.13.15c-3.41,3.51-9.15,8.83-13.52,9.88-6.64,1.58-4.78,11.76,9.94,13.46s16.49,1.56,26.84-7.07c9.12-7.6,10.57-11,10.78-11.73l.52.07s-5.55-20.62,0-29.34S941.21,579,941.21,579a171.47,171.47,0,0,1,.75-20.34c2.8,7.33,4.8,12.41,4.8,12.41s4.76,23,10.31,27,34.9,58.69,30.14,82.48l-.55,2.77,1.34-.39.12,0c-1.83,4.53-5.16,11.69-8.84,14.32-5.55,4,0,12.69,14.28,8.72s15.86-4.76,22.21-16.65S1021.31,674.16,1021.31,674.16Z",
    transform: "translate(-111.66 -29.85)",
    fill: "url(#40cb4f85-3adc-4f91-8af7-dda2654c63b5)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M916.21,462.4l-3.48-4.29a41.48,41.48,0,0,0-4.91,21.57l-5.18,73.83s-.78,16.28,4.65,28.69,22.49,74.44,10.86,79.09L953,666s-5.43-20.16,0-28.69-12.41-60.48-12.41-60.48-1.55-43.42,13.18-53.51S916.21,462.4,916.21,462.4Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#555388"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M922.09,658.38s-9.57,11.18-16.05,12.73-4.67,11.49,9.72,13.16,16.12,1.53,26.25-6.91,10.58-11.61,10.58-11.61-2-7.5-4.42-7.66S922.09,658.38,922.09,658.38Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#603556"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M918.54,464.73l-5.8-6.62a41.48,41.48,0,0,0-4.91,21.57l-5.18,73.83s-.78,16.28,4.65,28.69,22.49,74.44,10.86,79.09L953,666s-5.43-20.16,0-28.69-12.41-60.48-12.41-60.48-1.55-43.42,13.18-53.51S918.54,464.73,918.54,464.73Z",
    transform: "translate(-111.66 -29.85)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M953.06,565.92s-9.69-190.21-49.47-257.53c0,0-29.17-53.28-53.55-68.82v-6.14c-39.78-27.54-88.73,0-88.73,0v2.72l-10.2,8.5-45.93-.16a22.13,22.13,0,0,0-17.05-8H478.55a22.12,22.12,0,0,0-16.3,7.14h-47.7s-2.81-3.27-10.2-6.56v-3.64c-39.78-27.54-88.73,0-88.73,0v7.39a13.1,13.1,0,0,0-3.06,2.81s-40.29,27-49.47,60.68c0,0-49.47,148.4-50.49,264.67s43.86,132.59,67.31,135.65,65.27-1,106.07-104l17.34-60.17s3.06-35.7,39.78-13.26,69.35-12.24,69.35-12.24H650.15S696,543.48,737.86,521c0,0,16.32-21.42,31.62,51,0,0,46.92,148.91,119.33,133.61S953.06,565.92,953.06,565.92Z",
    transform: "translate(-111.66 -29.85)",
    fill: "url(#f74e0c91-e046-415c-8916-3730a2c068f9)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M320.84,248.93v-11s48-27,87,0v10Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#535461"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M757.84,248.93v-11s48-27,87,0v10Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#535461"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M320.84,248.93v-11s48-27,87,0v10Z",
    transform: "translate(-111.66 -29.85)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M757.84,248.93v-11s48-27,87,0v10Z",
    transform: "translate(-111.66 -29.85)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M464.84,247.93h-47s-12-14-52-13-48,13-48,13-39.5,26.5-48.5,59.5c0,0-48.5,145.5-49.5,259.5s43,130,66,133,64-1,104-102l17-59s3-35,39-13,68-12,68-12h135s45,28,86,6c0,0,16-21,31,50,0,0,46,146,117,131s63-137,63-137-9.5-186.5-48.5-252.5c0,0-37.5-68.5-62.5-71.5,0,0-54-10-75-1l-12,10Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#535461"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 244.18,
    cy: 316.08,
    r: 87,
    fill: "#e2e2ec"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.18,
    cy: 316.08,
    r: 87,
    fill: "#e2e2ec"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M371,326.53,359.4,336.79a5.38,5.38,0,0,1-7.11,0l-11.62-10.26a5.37,5.37,0,0,1-1.82-4V294.3a5.38,5.38,0,0,1,5.38-5.37h23.25a5.37,5.37,0,0,1,5.38,5.38v28.2A5.37,5.37,0,0,1,371,326.53Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#535461"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M371,365.32,359.4,355.07a5.38,5.38,0,0,0-7.11,0l-11.62,10.26a5.37,5.37,0,0,0-1.82,4v28.2a5.37,5.37,0,0,0,5.38,5.38h23.25a5.37,5.37,0,0,0,5.38-5.37v-28.2A5.37,5.37,0,0,0,371,365.32Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#535461"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M336.45,361.11l10.26-11.62a5.38,5.38,0,0,0,0-7.11l-10.26-11.62a5.38,5.38,0,0,0-4-1.82h-28.2a5.38,5.38,0,0,0-5.37,5.38v23.25a5.37,5.37,0,0,0,5.38,5.38h28.2A5.37,5.37,0,0,0,336.45,361.11Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#535461"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M375.24,361.11,365,349.48a5.37,5.37,0,0,1,0-7.11l10.26-11.62a5.37,5.37,0,0,1,4-1.82h28.2a5.37,5.37,0,0,1,5.38,5.38v23.25a5.37,5.37,0,0,1-5.37,5.38h-28.2A5.37,5.37,0,0,1,375.24,361.11Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#535461"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "229.18 252.08 259.18 252.08 244.18 239.08 229.18 252.08",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "229.18 380.08 259.18 380.08 244.18 393.08 229.18 380.08",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "180.18 301.08 180.18 331.08 167.18 316.08 180.18 301.08",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "308.18 301.08 308.18 331.08 321.18 316.08 308.18 301.08",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 362.18,
    cy: 411.08,
    r: 63,
    fill: "#e2e2ec"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.18,
    cy: 401.08,
    r: 42,
    fill: "#535461"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.18,
    cy: 411.08,
    r: 63,
    fill: "#e2e2ec"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.18,
    cy: 401.08,
    r: 42,
    fill: "#535461"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.18,
    cy: 401.08,
    r: 28,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.18,
    cy: 401.08,
    r: 28,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.18,
    cy: 418.08,
    r: 18,
    fill: "#e2e2ec"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 445.67,
    cy: 358,
    r: 3.93,
    fill: "#e2e2ec"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 460.39,
    cy: 358,
    r: 3.93,
    fill: "#e2e2ec"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.43,
    cy: 376.65,
    r: 3.93,
    fill: "#e2e2ec"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.18,
    cy: 377.08,
    r: 4,
    fill: "#e2e2ec"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 485.91,
    cy: 376.65,
    r: 3.93,
    fill: "#e2e2ec"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.54,
    cy: 367.82,
    r: 3.93,
    fill: "#e2e2ec"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 465.18,
    cy: 368.08,
    r: 4,
    fill: "#e2e2ec"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 478.18,
    cy: 368.08,
    r: 4,
    fill: "#e2e2ec"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 491.8,
    cy: 367.82,
    r: 3.93,
    fill: "#e2e2ec"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.18,
    cy: 358.08,
    r: 4,
    fill: "#e2e2ec"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.18,
    cy: 358.08,
    r: 4,
    fill: "#e2e2ec"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 497.69,
    cy: 358,
    r: 3.93,
    fill: "#e2e2ec"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 315.18,
    y: 225.08,
    width: 22,
    height: 38,
    rx: 8.5,
    ry: 8.5,
    fill: "#e2e2ec"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 607.18,
    y: 225.08,
    width: 22,
    height: 38,
    rx: 8.5,
    ry: 8.5,
    fill: "#e2e2ec"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 699.18,
    cy: 263.08,
    r: 24,
    fill: "#535461"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 648.18,
    cy: 314.08,
    r: 24,
    fill: "#535461"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 752.18,
    cy: 311.08,
    r: 24,
    fill: "#535461"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 703.18,
    cy: 364.08,
    r: 24,
    fill: "#535461"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 347.18,
    y: 211.08,
    width: 249,
    height: 133,
    rx: 21.75,
    ry: 21.75,
    fill: "#e2e2ec"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "684.68 273.08 698.68 249.08 713.68 273.08 684.68 273.08",
    fill: "none",
    stroke: "#e2e2ec",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 635.68,
    y: 303.08,
    width: 25,
    height: 22,
    fill: "none",
    stroke: "#e2e2ec",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 752.18,
    cy: 311.08,
    r: 14,
    fill: "none",
    stroke: "#e2e2ec",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 691.68,
    y1: 352.83,
    x2: 714.18,
    y2: 375.33,
    fill: "none",
    stroke: "#e2e2ec",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 714.68,
    y1: 352.83,
    x2: 691.68,
    y2: 374.83,
    fill: "none",
    stroke: "#e2e2ec",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M455.65,694.48c3-2.29,5.85-5,6.72-8.27a7,7,0,0,0-4.69-8.42c-4.31-1.34-8.91,1.09-12.41,3.55s-7.49,5.27-12.06,4.75c4.73-3.42,7-9,5.68-14a5.43,5.43,0,0,0-1.58-2.85c-2.39-2.09-6.73-1.19-9.59.45-9.11,5.23-11.65,15.32-11.7,24.41-.92-3.28-.14-6.69-.17-10.06s-1.15-7.09-4.63-8.9a16.55,16.55,0,0,0-7.06-1.35c-4.09-.12-8.66.21-11.45,2.66-3.47,3-2.57,8.13.45,11.47s7.62,5.44,11.85,7.75c3.23,1.76,6.49,3.81,8.47,6.59a6,6,0,0,1,.63,1.18h25.67A73.8,73.8,0,0,0,455.65,694.48Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#6c63ff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M987.94,674.49s-4.65,14-10.08,17.84,0,12.41,14,8.53,15.51-4.65,21.71-16.28,5.43-14.73,5.43-14.73-4.65-6.2-7-5.43S987.94,674.49,987.94,674.49Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#603556"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M959.25,326.31s-62.81,34.89-48.08,24.81c9.9-6.77,9.3-24.74,7.84-35.81-.46-3.45-1-6.23-1.33-7.79-.19-.88-.31-1.37-.31-1.37s30.46-18.28,28.75-7.29h0c0,.1,0,.2-.05.3a11.85,11.85,0,0,0-.23,2.23C945.63,312.69,959.25,326.31,959.25,326.31Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#c87486"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M891,360.43s-5.43,8.53-14.73,0-38.77-34.12-38.77-34.12S824.32,293.74,815,299.95s10.86,36.45,10.86,36.45l44.2,47.3s1.55,10.08,17.84,4.65,27.92-10.08,27.92-10.08Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#c87486"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M915.83,439.53",
    transform: "translate(-111.66 -29.85)",
    fill: "none"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.41,667.51l-31,10.86-1.31.38.54-2.71c4.65-23.26-24-76.77-29.47-80.65S946.07,569,946.07,569s-10.16-51.18-11.71-62c-.39-2.71-1.81-4.87-3.53-7.85a62.12,62.12,0,0,1-6-14.36c-3.41-12-11.36-33.3-8.44-45.35.59-2.45-1.82,3.81-1,1.42l.47-1.32L978.64,431a46.9,46.9,0,0,1,2.92,3.95C986.31,442,986,442,987,455.4a138.26,138.26,0,0,1-3.41,24c-8.45,37.63,10.61,88,10.61,88s15.51,35.67,12.41,50.4S1017.41,667.51,1017.41,667.51Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#555388"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M981.56,434.94c-9.29,11.65-68.8,20.7-68.06,17a7.86,7.86,0,0,0-.28-3.82,75.69,75.69,0,0,1,2.14-7.27l.47-1.32L978.64,431A46.9,46.9,0,0,1,981.56,434.94Z",
    transform: "translate(-111.66 -29.85)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M954.6,310S929,317.78,922,335.62s5.31,18.81,5.31,18.81-22,58-16.17,88.2c0,0,3.1,3.88,2.33,7.75s64.36-6.2,69-18.61-21.71-34.89-14.73-55.83S954.6,310,954.6,310Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#dfe5ee"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M946.07,300.72a2.45,2.45,0,0,1-.23.67c-1.06,2-4.43-.19-3.26,2.81-4.5,4.52-5.92,13.57-12.79,13.57A24.66,24.66,0,0,1,919,315.32c-.46-3.45-1-6.23-1.33-7.79,3-1.78,27-15.68,28.44-8.66h0A4.61,4.61,0,0,1,946.07,300.72Z",
    transform: "translate(-111.66 -29.85)",
    opacity: 0.1
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.12,
    cy: 261.57,
    r: 24.81,
    fill: "#c87486"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M954.6,370.51l-43.42,20.16S881.71,368.19,886.36,362s41.1-24,41.1-24S964.68,345.7,954.6,370.51Z",
    transform: "translate(-111.66 -29.85)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M954.6,369l-43.42,20.16s-29.47-22.49-24.81-28.69,41.1-24,41.1-24S964.68,344.15,954.6,369Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#dfe5ee"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M922.62,280.79c-3.79-.38-7.71-.8-11-2.71-1.91-1.1-3.66-2.92-3.72-5.13-.07-2.6,2.12-4.63,4.13-6.28a15.08,15.08,0,0,1,4.45-2.85c2.15-.75,4.5-.48,6.77-.67,6.68-.56,12.66-5.1,19.37-5.06,4.93,0,9.46,2.52,13.75,4.95,3.43,1.94,7.24,4.4,7.81,8.3a36.31,36.31,0,0,0,.31,3.76c.71,2.78,3.7,4.4,4.77,7.06,1.17,2.91-.31,6.28-2.47,8.55s-5,3.83-7.27,5.95A20.38,20.38,0,0,0,953,312a2,2,0,0,1-.17,1.11,1.94,1.94,0,0,1-1.4.7c-2.47.46-5.52.71-7-1.33s-.31-5.44-2-7.45c-2.15-2.59-6.67-.53-9.58-2.23a5.82,5.82,0,0,1-2.2-2.63C928.25,295,931,290.94,932,286,933.17,280.23,926.69,281.2,922.62,280.79Z",
    transform: "translate(-111.66 -29.85)",
    opacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M923.4,280c-3.79-.38-7.71-.8-11-2.71-1.91-1.1-3.66-2.92-3.72-5.13-.07-2.6,2.12-4.63,4.13-6.28a15.08,15.08,0,0,1,4.45-2.85c2.15-.75,4.5-.48,6.77-.67,6.68-.56,12.66-5.1,19.37-5.06,4.93,0,9.46,2.52,13.75,4.95,3.43,1.94,7.24,4.4,7.81,8.3a36.31,36.31,0,0,0,.31,3.76c.71,2.78,3.7,4.4,4.77,7.06,1.17,2.91-.31,6.28-2.47,8.55s-5,3.83-7.27,5.95a20.38,20.38,0,0,0-6.53,15.38,2,2,0,0,1-.17,1.11,1.94,1.94,0,0,1-1.4.7c-2.47.46-5.52.71-7-1.33s-.31-5.44-2-7.45c-2.15-2.59-6.67-.53-9.58-2.23a5.82,5.82,0,0,1-2.2-2.63c-2.42-5.18.34-9.27,1.34-14.26C933.94,279.45,927.46,280.43,923.4,280Z",
    transform: "translate(-111.66 -29.85)",
    fill: "#603456"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e9176102b57c5f9a1fc1b20adebc3037.svg";
export { ForwardRef as ReactComponent };